import { render, staticRenderFns } from "./UnitCompare.vue?vue&type=template&id=b5a05312&"
import script from "./UnitCompare.vue?vue&type=script&lang=js&"
export * from "./UnitCompare.vue?vue&type=script&lang=js&"
import style0 from "./UnitCompare.vue?vue&type=style&index=0&id=b5a05312&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports